module.exports = __webpack_public_path__ + "img/ramsons_pre_wash.1674eb88.jpg";